module.exports = __webpack_public_path__ + "img/bg.03a6917d.png";